import '../stylesheets/application.scss';
import * as $ from 'jquery';
import 'bootstrap/dist/js/bootstrap';
import '@oddcamp/cocoon-vanilla-js';
import moment from 'moment';
import flatpickr from 'flatpickr';
import Sortable from 'sortablejs';
import {
  statusChart, attendanceChart, ballotResultsChart, specialStatesChart,
} from '../charts';

require('@rails/ujs').start();
require('turbolinks').start();
require('@rails/activestorage').start();

window.$ = window.jQuery = $; // eslint-disable-line no-multi-assign
const ranks = {};

const updateRanks = () => {
  $('.ranking .list-group-item').each((i, e) => {
    const $select = $(e).find('select[id$="rank"]');
    $select.val(i + 1);
    ranks[$select.attr('name')] = i + 1;
  });
};

const validateEndsAt = (startsAt, endsAt) => {
  $('#ballot_ends_at').removeClass('alert-danger');
  if (endsAt <= startsAt) {
    $('#ballot_ends_at').addClass('alert-danger');
  }
};

document.addEventListener('turbolinks:load', () => {
  const ranking = document.querySelector('.ranking');
  if (ranking) {
    Sortable.create(ranking, {
      draggable: '.list-group-item',
      handle: '.drag-handle',
      ghostClass: 'ghost',

      onUpdate: updateRanks,
    });

    $('select[id$="rank"]').on('change', (e) => {
      const $changedSelect = $(e.target);
      const rank = $changedSelect.val();
      const previousRank = ranks[$changedSelect.attr('name')];
      const $originalRank = $(`select[id$="rank"] option[value="${rank}"]:selected`).parent().not($changedSelect);
      const $changedItem = $changedSelect.parent('.list-group-item');
      const $originalItem = $originalRank.parent('.list-group-item');

      if (rank > previousRank) {
        $changedItem.insertAfter($originalItem);
      } else {
        $changedItem.insertBefore($originalItem);
      }

      updateRanks();
    });

    updateRanks();
  }

  flatpickr('.datetime-picker', {
    allowInput: true,
    enableTime: true,
  });

  $('.datetime-picker').change(() => {
    const startsAt = moment($('#ballot_starts_at').val(), 'YYYY-MM-DD h:mm');
    const endsAt = moment($('#ballot_ends_at').val(), 'YYYY-MM-DD h:mm');
    validateEndsAt(startsAt, endsAt);
  });

  const statusChartEl = $('.status-chart')[0];
  if (statusChartEl) {
    const ballotsSubmitted = $(statusChartEl).attr('data-ballots-submitted');
    const ballotsRemaining = $(statusChartEl).attr('data-ballots-remaining');
    statusChart(statusChartEl, ballotsSubmitted, ballotsRemaining);
  }

  $('.attendance-chart').each((i, e) => {
    const checkedOutCount = $(e).attr('data-checked-out-count');
    const checkedInCount = $(e).attr('data-checked-in-count');
    attendanceChart(e, checkedInCount, checkedOutCount);
  });

  $('.ballot-results-chart').each((i, e) => {
    const data = JSON.parse($(e).attr('data-results'));
    const labels = JSON.parse($(e).attr('data-labels'));
    ballotResultsChart(e, data, labels);
  });

  $('.special-states-chart').each((i, e) => {
    const data = JSON.parse($(e).attr('data-results'));
    const labels = JSON.parse($(e).attr('data-labels'));
    specialStatesChart(e, data, labels);
  });

  $('#clear-button').on('click', (e) => {
    const $form = $(e.target).parents('form');
    $('[type="search"]', $form).val('');
    $form.submit();
  });

  const $defaultResultLimitInput = $('input[name="ballot[default_result_limit]"]');
  const $form = $defaultResultLimitInput.parents('form');

  const updateDefaultResultLimit = () => {
    const defaultResultLimitMax = $('.question-option-form-lines .nested-fields', $form).length;
    $defaultResultLimitInput.attr('max', defaultResultLimitMax);
  };

  $form.on('cocoon:after-insert', updateDefaultResultLimit);
  $form.on('cocoon:after-remove', updateDefaultResultLimit);

  updateDefaultResultLimit();
});
